// internal imports
import BaseCommand from "./baseCommand";
import { DOCUMENTS } from "../constants";

// Destructuring
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class ToggleSectionLockCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    this.command(this.componentData.lockStatus);
  }

  undo() {
    if (
      this.componentData &&
      this.componentData.payload &&
      this.componentData.payload.oldSection
    ) {
      this.scrollIntoView(this.componentData.payload.oldSection.id);
    }
    this.command(!this.componentData.lockStatus);
  }

  command(lockStatus) {
    const {
      blockContent,
      updateComponent,
      updateDocumentClickedComponentID,
      updateHoveredSectionId,
      nukeEditorState,
    } = this.componentData;
    const { content: block } = blockContent;
    if (block && block.data && block.data.components) {
      if (block.type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
        Object.keys(block.data.components).map(compID => {
          block.data.components[compID].content.lock = lockStatus;
          return null;
        });
      }
    }

    if (
      block &&
      block.data &&
      block.data.header &&
      block.data.header.components &&
      block.data.footer &&
      block.data.footer.components
    ) {
      Object.keys(block.data.header.components).map(compID => {
        block.data.header.components[compID].content.lock = lockStatus;
        return null;
      });
      Object.keys(block.data.footer.components).map(compID => {
        block.data.footer.components[compID].content.lock = lockStatus;
        return null;
      });
    }
    const newBlock = {
      ...block,
      lock: lockStatus,
    };
    updateComponent(newBlock, undefined, false, blockContent, undefined, false);
    updateDocumentClickedComponentID(null, true, null);
    updateHoveredSectionId(null, null);
    nukeEditorState();
  }
}

export default ToggleSectionLockCommand;



// WEBPACK FOOTER //
// ./src/commands/toggleSectionLockCommand.js